var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1DEE4"
    },
    points: "294.555,418.351 407.033,388.212 426.029,318.857 205.02,315.974 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFF6F9"
    },
    points: "130.948,397.924 182.076,448.489 294.555,418.351 262.962,300.447 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.795,68.435c28.412-7.613,58.004-6.377,85.58,3.576c26.879,9.701,50.001,26.944,66.878,49.875l23.379,30.469 L195.018,278.647L200.795,68.435z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#012231"
    },
    d: "M200.795,68.435c-28.412,7.612-53.422,23.48-72.327,45.887c-18.428,21.84-29.83,48.335-32.981,76.631 l-5.012,38.077l162.486,34.091L200.795,68.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B8FA"
    },
    d: "M200.899,242.652l309.423-36.332c9.33,34.818-20.419,75.484-84.334,112.385l-147.541,39.533 L200.899,242.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CD4FF"
    },
    d: "M244.356,231.007L1.679,342.609c9.329,34.818,55.425,55.161,129.227,55.161l147.541-39.533 L244.356,231.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#012231"
    },
    d: "M256.001,274.465l254.321-68.145c-9.329-34.818-55.425-55.161-129.227-55.161 c-1.576,0-147.541,39.533-147.541,39.533l-32.234,53.53L256.001,274.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#014059"
    },
    d: "M256.001,274.465L1.679,342.61c-9.33-34.818,20.419-75.484,84.334-112.385 c1.365-0.788,147.541-39.533,147.541-39.533L256.001,274.465z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexDisk);
export default __webpack_public_path__ + "static/media/yandex-disk.755e8693e1b583229b92c89e00584bc4.svg";
export { ForwardRef as ReactComponent };